<template>
  <div class="nd-input">
    <template v-if="type === 'textarea'">
      <textarea
        class="nd-input-inner"
        v-model="bindValue"
        :class="[{'clearble': currentValue && isFocus}, textAlign]"
        :name="name"
        :placeholder="placeholder"
        :readonly="readonly"
        :disabled="disabled"
        :autocomplete="autocomplete"
        :maxLength="maxLength"
        :minLength="minLength"
        :max="max"
        @change="onChange"
        @blur="onBlur"
        @focus="onFocus"
        @input="onInput"
        :rows="autoSize ? 1 : rows"
        ref="input"
      >
      </textarea>
    </template>
    <template v-else>
      <input
        class="nd-input-inner"
        :class="[{'clearble': currentValue && isFocus}, textAlign]"
        :type="type === 'number' ? 'text' : type"
        v-model="bindValue"
        :name="name"
        :placeholder="placeholder"
        :readonly="readonly"
        :disabled="disabled"
        :autocomplete="autocomplete"
        :maxLength="maxLength"
        :minLength="minLength"
        :max="max"
        :style="inputStyle"
        @change="onChange"
        @blur="onBlur"
        @focus="onFocus"
        @input="onInput"
        ref="input"
      >
    </template>
    <label :for="name" v-if="label">{{ label }}</label>
    <template v-if="clearBtn">
      <i class="clearbtn" :class="type" v-show="currentValue && isFocus && !readonly" @click="clearInput"></i>
    </template>
    <input
      type="hidden"
      :value="currentValue"
    >
  </div>
</template>
<script>
export default {
  name: 'nd-input',

  data () {
    return {
      currentValue: this.value,
      bindValue: this.value,
      isFocus: false,
      customType: ''
    }
  },

  watch: {
    value (value) {
      this.setCurrentValue(value)
      this.$nextTick(this.adjustHeight)
    },

    bindValue (value) {
      this.updateValue(value)
      this.$nextTick(this.adjustHeight)
    }
  },

  created () {
    this.$nextTick(this.adjustHeight)
  },
  mounted () {
    console.log('nd-input', this.name)
  },

  props: {
    value: {
      // eslint-disable-next-line vue/require-prop-type-constructor
      type: Number | String
    },
    type: {
      type: String,
      default: 'text'
    },
    name: String,
    placeholder: {
      type: String,
      default: '请输入'
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    label: String,
    textAlign: {
      type: String,
      default: 'left'
    },
    autocomplete: String,
    maxLength: String,
    minLength: String,
    inputStyle: String,
    // eslint-disable-next-line vue/require-prop-type-constructor
    max: Number | String,
    autoSize: {
      type: Boolean,
      default: true
    },
    // eslint-disable-next-line vue/require-prop-type-constructor
    rows: String | Number,
    clearBtn: {
      type: Boolean,
      default: true
    },
    clearAdaptCompute: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    onChange (...arg) {
      this.$emit('change', ...arg)
    },

    onBlur (...arg) {
      this.$emit('blur', ...arg)
      if (this.type === 'number') {
        this.currentValue = this.currentValue.replace(/\.$/, '')
      }
      // 要兼容电脑端访问需要把这个时间设置得更长
      setTimeout(() => {
        this.isFocus = false
        this.$nextTick(this.adjustHeight)
      }, this.clearAdaptCompute ? 200 : 100)
    },

    onFocus (...arg) {
      this.isFocus = true
      this.$emit('focus', ...arg)
      this.$nextTick(this.adjustHeight)
    },

    onInput (...arg) {
      // 纯数字，不含小数点
      if (this.type === 'pure-number') {
        this.bindValue = this.bindValue.replace(/\D+/g, '')
        return
      }
      if (this.type === 'number') {
        if (/^(\d+(\.\d+)?)$/.test(this.bindValue) || /^\d+\.$/.test(this.bindValue)) {
          this.bindValue.replace(/^(\d+)(\.\d+)?$/g, (o, $1, $2) => {
            this.bindValue = `${$1}${$2 || ''}`
          })
        } else {
          if (/^(\d+(\.\d+)?)\.$/.test(this.bindValue)) {
            this.bindValue = this.bindValue.replace(/\.$/, '')
          } else {
            this.bindValue = this.bindValue.replace(/\D+/g, '')
          }
        }
        if (this.bindValue > this.max) {
          this.bindValue = Math.floor(this.bindValue / 10) + ''
        }
        return
      }
      this.$emit('on-input', ...arg)
    },

    setCurrentValue (value) {
      if (value === this.currentValue) return
      this.currentValue = value
      this.$emit('input', value)
      this.$refs['input'].dispatchEvent(new Event('input'))
      this.$refs['input'].dispatchEvent(new Event('change'))
      this.bindValue = value
    },

    updateValue (value) {
      if (this.value === value) return
      this.$emit('input', value)
      this.$refs['input'].dispatchEvent(new Event('input'))
      this.$refs['input'].dispatchEvent(new Event('change'))
      this.currentValue = value
    },

    clearInput () {
      this.setCurrentValue('')
    },

    adjustHeight () {
      const { input } = this.$refs
      if (!(this.type === 'textarea' && this.autoSize) || !input) return

      input.style.height = 'auto'
      let height = input.scrollHeight

      if (height) {
        input.style.height = height + 'px'
      }
    },

    focus () {
      const input = this.$refs['input']
      input.dispatchEvent(new Event('focus'))
      this.setCaretPosition(input, this.value.length)
    },

    setCaretPosition (ctrl, pos) {
      setTimeout(() => {
        ctrl.setSelectionRange(pos, pos)
        ctrl.focus()
      }, 0)
    }
  }
}
</script>
<style lang="less" scoped>
@import "../../assets/less/mixin.less";

    .nd-input {
        position: relative;
        height: 100%;
        width: 100%;

        input {
            border: none;
            outline: none;
            width: 100%;
            height: 100%;
            color: @fc1;
            font-size: 32px;
            background: transparent;
            padding-right: 15px;
            overflow: hidden;
            text-overflow: ellipsis;
            font-family: 'PingFangSC-Regular';
            font-weight: 500;
            box-sizing: border-box;
            caret-color: @theme;
            display: block;
            &.nd-input-inner{
                &.right {
                    text-align: right;
                }
                &.center {
                    text-align: center;
                }
                &.clearble {
                    padding-right: 50px;
                }
            }
            &::-moz-placeholder { color: @fc4; }
            &:-moz-placeholder { color: @fc4; }
            &::-webkit-input-placeholder { color: @fc4; }
            &:-ms-input-placeholder { color: @fc4; }
            &:disabled {
                background-color: transparent;
            }
            &[type="password"] {
                -webkit-text-security: square!important;
            }
        }
        textarea {
            border: none;
            outline: none;
            width: 100%;
            height: 100%;
            color: @fc1;
            font-size: 28px;
            padding-right: 15px;
            caret-color: @theme;
            background: transparent;
            resize: none;
            font-family: 'PingFangSC-Regular';
            font-weight: 500;
            line-height: 1.4em;
            -webkit-text-size-adjust: none;
          display: block;
            &.nd-input-inner{
                &.right {
                    text-align: right;
                }
                &.center {
                    text-align: center;
                }
                &.clearble {
                    padding-right: 50px;
                }
            }
            &:disabled {
                background-color: transparent;
            }
            &::-moz-placeholder { color: @fc4; }
            &:-moz-placeholder { color: @fc4; }
            &::-webkit-input-placeholder { color: @fc4; }
            &:-ms-input-placeholder { color: @fc4; }
        }
        label {
            position: absolute;
            height: 90%;
            left: 0;
            top: 0;
            font-size: 30px;
            background-color: #fff;
            font-family: 'PingFangSC-Regular';
            font-weight: 400;
        }
        .clearbtn {
            position: absolute;
            top: 50%;
            right: 10px;
            height: 30px;
            margin-top: -15px;
            width: 30px;
            display: block;
            background-image: url(./images/close.svg);
            background-size: 100% 100%;
            background-position: center center;
            z-index: 10;
            cursor: pointer;
            &.textarea {
                top: 5px;
                margin-top: 0;
            }
        }
    }
</style>